export const handleSearch = (query, searchQuery) => {
  return query?.toLowerCase().trim().includes(searchQuery.toLowerCase().trim());
};
